// Locations mapped to regions in Ghana
const locations = {
  "Greater Accra": [
    "Accra",
    "Tema",
    "Ashaiman",
    "Madina",
    "Adenta",
    "Dansoman",
    "Kokomlemle",
    "Kaneshie",
    "Osu",
    "Labone",
    "East Legon",
    "West Legon",
    "Achimota",
    "Tesano",
    "Abelemkpe",
    "Other"
  ],
  "Ashanti": [
    "Kumasi",
    "Obuasi",
    "Mampong",
    "Ejisu",
    "Konongo",
    "Bekwai",
    "Asante Mampong",
    "Offinso",
    "Tafo",
    "Suame",
    "Asokwa",
    "Kwadaso",
    "Manhyia",
    "Other"
  ],
  "Western": [
    "Takoradi",
    "Sekondi",
    "Tarkwa",
    "Prestea",
    "Bogoso",
    "Dunkwa",
    "Axim",
    "Half Assini",
    "Elubo",
    "Enchi",
    "Other"
  ],
  "Central": [
    "Cape Coast",
    "Winneba",
    "Saltpond",
    "Elmina",
    "Mankessim",
    "Swedru",
    "Kasoa",
    "Dunkwa",
    "Twifo Praso",
    "Other"
  ],
  "Northern": [
    "Tamale",
    "Yendi",
    "Savelugu",
    "Bimbilla",
    "Damongo",
    "Bole",
    "Salaga",
    "Other"
  ],
  "Eastern": [
    "Koforidua",
    "Nkawkaw",
    "Mpraeso",
    "Aburi",
    "Nsawam",
    "Suhum",
    "Akim Oda",
    "Asamankese",
    "Other"
  ],
  "Volta": [
    "Ho",
    "Hohoe",
    "Keta",
    "Kpando",
    "Anloga",
    "Keta",
    "Aflao",
    "Other"
  ],
  "Upper East": [
    "Bolgatanga",
    "Bawku",
    "Navrongo",
    "Bongo",
    "Zebilla",
    "Sandema",
    "Other"
  ],
  "Upper West": [
    "Wa",
    "Tumu",
    "Jirapa",
    "Lawra",
    "Nandom",
    "Other"
  ],
  "Bono": [
    "Sunyani",
    "Berekum",
    "Dormaa Ahenkro",
    "Wenchi",
    "Jaman North",
    "Other"
  ],
  "Bono East": [
    "Techiman",
    "Atebubu",
    "Nkoranza",
    "Kintampo",
    "Pru East",
    "Other"
  ],
  "Ahafo": [
    "Goaso",
    "Hwidiem",
    "Kenyasi",
    "Duayaw Nkwanta",
    "Other"
  ],
  "Savannah": [
    "Damongo",
    "Bole",
    "Salaga",
    "Yapei",
    "Other"
  ],
  "North East": [
    "Nalerigu",
    "Gambaga",
    "Walewale",
    "Other"
  ],
  "Oti": [
    "Dambai",
    "Jasikan",
    "Kadjebi",
    "Krachi East",
    "Other"
  ],
  "Western North": [
    "Sefwi Wiawso",
    "Bibiani",
    "Juaboso",
    "Other"
  ]
};

export default locations;
